/**
* 被害種別選択用grid
* @module app/signage/damagetype/DamageTypeGrid
*/
define([
    'module',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/_base/array',
    'dijit/form/RadioButton',
    'dijit/form/CheckBox',
    'idis/view/grid/IdisGrid',
    'idis/view/grid/helper'
], function (module, declare, lang, array, RadioButton, CheckBox,
    IdisGrid, helper) {

    return declare(module.id.replace(/\//g, '.'), IdisGrid, {

        // ルート要素に付与されるCSS
        baseClass: 'idis-Page idis-Page--damage-list',

        checkboxes: {},

        mainTypeIds: [],

        constructor: function () {
            /**
             * 各列の定義
             * @type {Object[]}
             */
            this.columns = [
                {
                    field: 'main', label: '選択', sortable: false,

                    renderCell: lang.hitch(this, function(item) {
                        this.checkboxes[item.damageTypeId] = new CheckBox({
                            onClick: lang.hitch(this, function() {
                                this._onCheckBox(item);
                            })
                        });
                        // HTMLとしてウィジェットに紐付くDOMノードを返す
                        return this.checkboxes[item.damageTypeId].domNode;
                    })
                },
                helper.column('damageType', '被害種別')
            ];

            this.inherited(arguments);
        },

        reset: function() {
            this.inherited(arguments);

            this.checkboxes = {};
            this.mainTypeIds = [];
        },

        /**
         *  チェックボックスを押した時
         * @param {*} item 押された行の内容
         */
        _onCheckBox: function(item) {
            if (this.checkboxes[item.damageTypeId].get('checked')) {
                // チェック状態である => 今回追加されたのでmainTypeIdsに入れる
                this.mainTypeIds.push(item.damageTypeId);
            } else {
                // チェック状態でない => mainTypeIdsにあったら削除
                var index = array.indexOf(this.mainTypeIds, item.damageTypeId);
                if (index !== -1) {
                    this.mainTypeIds.splice(index, 1);
                }
            }
        }
    });
});
